import axios, { type AxiosResponse } from 'axios'

import { type YurplanConfigurationDto } from '@/pages/yurplanTickets/yurplanTickets.types'
import { type Attendee } from '@/shared/types/attendee.type'

export const TicketsService = {
  async getYurplanConfiguration(): Promise<YurplanConfigurationDto> {
    const { data } = await axios.get('/api/yurplan-configuration')
    return data
  },

  async updateYurplanConfiguration(
    yurplanConfiguration: YurplanConfigurationDto,
  ): Promise<YurplanConfigurationDto> {
    const { data } = await axios.put(
      '/api/yurplan-configuration',
      yurplanConfiguration,
    )
    return data
  },

  async getAll(
    query: string,
    page: number,
    itemsPerPage: number,
    sortBy: string,
    desc: boolean,
  ): Promise<{ attendees: Attendee[]; total: number }> {
    const { data } = await axios.get('/api/tickets', {
      params: {
        query,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        order: sortBy,
        desc,
      },
    })
    return data
  },

  async importTickets(
    file: string | ArrayBuffer | null,
  ): Promise<AxiosResponse<string>> {
    return await axios.post<string>('/api/tickets/upload-csv', {
      file,
    })
  },

  async syncYurplan() {
    return await axios.post('/api/tickets/force-synchro-yurplan', {
      fullSynchro: true,
    })
  },
}
